import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function PlatformCTA() {
  return (
    <section className="py-20 md:py-28 bg-foreground">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-5">
          Ready to close the loop on procedure revenue?
        </h2>
        <p className="text-gray-400 text-lg max-w-xl mx-auto mb-10">
          See how LINK delivers audit-defensible billing with zero compliance risk.
        </p>
        <Button
          size="lg"
          className="bg-cta hover:bg-cta/90 text-cta-foreground font-bold h-12 px-8 rounded-md"
          asChild
        >
          <a href="/#executive-cta">
            Schedule Executive Demo
            <ArrowRight className="ml-2 h-4 w-4" />
          </a>
        </Button>
      </div>
    </section>
  );
}
